import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import type { InterpretiveReportDto } from '../../../hooks/queries/useGetInterpretiveReportQuery';
import { SectionHead } from './SectionHead';
import styles from '../InterpretiveReportPage.module.css';

type DevelopmentPathProps = {
  number: string;
  stage: InterpretiveReportDto['developmentStage'];
};

export const DevelopmentPath = ({ number, stage }: DevelopmentPathProps) => {
  const { t } = useTranslation();
  return (
    <section>
      <SectionHead
        number={number}
        eyebrow={t('interpretiveReport.document.trajectory.eyebrow')}
        title={t('interpretiveReport.document.trajectory.title')}
        intro={t('interpretiveReport.document.trajectory.intro')}
      />
      <div className={cn(styles.stages, styles.keep)}>
        <div className={cn(styles.stage, styles.currentStage)}>
          <span className={styles.stageLabel}>{t('interpretiveReport.document.trajectory.current')}</span>
          <h3 className={styles.stageName}>{stage.currentStageName}</h3>
          <p className={styles.stageText}>{stage.currentStageDescription}</p>
        </div>
        <div className={styles.stage}>
          <span className={styles.stageLabel}>{t('interpretiveReport.document.trajectory.next')}</span>
          <h3 className={styles.stageName}>
            {stage.nextStageName || t('interpretiveReport.document.trajectory.atTop')}
          </h3>
        </div>
      </div>
      {stage.pitfalls.length > 0 && (
        <div className={cn(styles.pitfalls, styles.keep)}>
          <h3 className={styles.readingTitle}>{t('interpretiveReport.document.trajectory.pitfalls')}</h3>
          <ul className={styles.pitfallList}>
            {stage.pitfalls.map((pitfall) => (
              <li key={pitfall} className={styles.pitfall}>
                <span aria-hidden="true" className={styles.pitfallDot} />
                <span>{pitfall}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};
